import { Button, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { vehicle_save_to_db } from "./VehicleFunctions";
import { useUserData } from "src/context/userContext";

import MyDivider from "../layout/MyDivider";
import StepButtons from "../buttons/StepButtons/StepButtons";
import { lazy, useEffect, useState } from "react";
import LazyLoader from "../layout/Progress/LazyLoader";
import MyDateRangeSelector from "../MyDateRangeSelector/MyDateRangeSelector";
import { CloseIcon } from "../icons/ActionIcons";
import MySwitch from "../MySwitch/MySwitch";
import EditVehicle_DefaultKuski_Dropdown from "./EditVehicle_DefaultKuski_Dropdown";
import TuoteSelecorModal from "../tuotteet/tuoteSelector/TuoteSelectorModal";

const VehicleTypeSelectorDropDown = lazy(() =>
  import("src/components/vehicle/VehicleTypeSelectorDropDown")
);

export default function EditVehicle(props) {
  const { token, socket, ownerAsiakasId } = useUserData();
  const [vehicle, setVehicle] = useState();
  const [dates, setDates] = useState({
    startDate: props.vehicle?.firstDate,
    endDate: props.vehicle?.lastDate,
  });
  const [tuoteSelectorIsOpen, setTuoteSelectorIsOpen] = useState(false);

  useEffect(() => {
    setVehicle(props.vehicle);
    setDates({ startDate: props.vehicle?.firstDate, endDate: props.vehicle?.lastDate });
    document.title = "Ajoneuvo " + props.vehicle?.vehicleRegNo;
  }, [props.vehicle]);
  console.log(vehicle);
  const vehicleTypeId = vehicle?.vehicleTypeId || "??";
  const setVehicleType = (vehicleType) => {
    vehicle.vehicleTypeId = vehicleType.vehicleTypeId;
    vehicle.vehicleTypeName = vehicleType.vehicleTypeName;
    vehicle.vehicleTypeShortName = vehicleType.vehicleTypeShortName;
    setVehicle(vehicle);
  };

  const handleTuoteSelectorClose = (tuote) => {
    if (tuote) {
      vehicle.tuoteId = tuote.tuoteId;
      vehicle.tuoteNimike = tuote.nimike;
      setVehicle(vehicle);
      props.setVehicle(vehicle);
    } else console.log("handleTuoteSelectorClose, no tuote");
    setTuoteSelectorIsOpen(false);
  };

  const handleInputChange = (event, field) => {
    if (event?.target) {
      const newVehicle = { ...vehicle, [field]: event.target.value };
      setVehicle(newVehicle);
    } else {
      const newVehicle = { ...vehicle, [field]: event };
      setVehicle(newVehicle);
    }
  };

  const handleSaveClick = async () => {
    const a = await vehicle_save_to_db(vehicle, token, socket);
    props.setVehicle(vehicle);
    props.onClose(true);
    console.log(a);
    return a;
  };

  const doSetDates = (dates) => {
    setDates(dates);
    vehicle.firstDate = dates.startDate;
    vehicle.lastDate = dates.endDate;
    setVehicle(vehicle);
  };

  if (!vehicle) return;

  return (
    <div className="flexCol" style={{ gap: 20, marginTop: "10px" }}>
      <div className="spaceBetween" style={{ gap: 20 }}>
        <TextField
          sx={{ width: "150px" }}
          label="Rekisterinumero"
          value={vehicle?.vehicleRegNo || ""}
          onChange={(event) => handleInputChange(event, "vehicleRegNo")}
          // disabled
        />
        <TextField
          sx={{ width: "250px" }}
          label="Ajoneuvon nimi"
          value={vehicle?.vehicleNimi || ""}
          onChange={(event) => handleInputChange(event, "vehicleNimi")}
          fullWidth
        />
        <div>
          <Typography variant="caption">Laskutustuote</Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setTuoteSelectorIsOpen(true)}
            style={{ width: "150px" }}>
            <div className="center">
              <span style={{ fontSize: 14, marginLeft: 5 }}>
                {vehicle?.tuoteNimike ? vehicle?.tuoteNimike : "Ei valittu"}
              </span>
            </div>
          </Button>
        </div>
        <div style={{ width: "200px" }}>
          <LazyLoader>
            <VehicleTypeSelectorDropDown
              vehicleTypeId={vehicleTypeId}
              setVehicleType={setVehicleType}
            />
          </LazyLoader>
        </div>
      </div>
      <div className="spaceBetween" style={{ gap: 20 }}>
        <TextField
          sx={{ width: "150px" }}
          label="Ajoneuvon numero"
          value={vehicle?.vehicleNo || ""}
          onChange={(event) => handleInputChange(event, "vehicleNo")}
        />
        <TextField
          sx={{ width: "150px" }}
          label="Puomin pituus"
          value={vehicle?.vehiclePuomi || ""}
          onChange={(event) => handleInputChange(event, "vehiclePuomi")}
          InputProps={{
            endAdornment: <>m</>,
          }}
        />
        <TextField
          sx={{ width: "150px" }}
          label="Järjestysnumero"
          value={vehicle?.sortNo || ""}
          onChange={(event) => handleInputChange(event, "sortNo")}
        />
        <div style={{ width: "300px" }}>
          <EditVehicle_DefaultKuski_Dropdown vehicle={vehicle} setVehicle={setVehicle} />
        </div>
      </div>
      <MyDivider />
      <MyDateRangeSelector disabled={false} dates={dates} setDates={doSetDates} fullWidth />
      <div style={{ width: "100%" }}>
        <MySwitch
          rightSide="Näytä ajoneuvo ruudukossa (grid)"
          checked={vehicle?.showInGrid}
          onChange={(event) => handleInputChange(event, "showInGrid")}
        />
        <MySwitch
          rightSide="Näytä ajoneuvo raporteissa"
          checked={vehicle?.showInGrid}
          onChange={(event) => handleInputChange(event, "showInReports")}
        />
        <MySwitch
          rightSide="Laita 'ei kuljettajaa' palkki, jos ajoneuvolle ei ole määritetty kuljettajaa kyseiselle päivälle"
          checked={vehicle?.useNoDriverBar}
          onChange={(event) => handleInputChange(event, "useNoDriverBar")}
        />
      </div>
      <MyDivider />
      <TextField
        label="Lisätietoja"
        value={vehicle?.memo || ""}
        multiline
        fullWidth
        onChange={(event) => handleInputChange(event, "memo")}
      />
      <div style={{ width: "100%" }}>
        <StepButtons
          closeText="SULJE"
          closeIcon={<CloseIcon />}
          enableButtonAfterKlik
          onCancelKlik={() => props.onClose(false)}
          onSaveKlik={handleSaveClick}
        />
      </div>
      <TuoteSelecorModal
        open={tuoteSelectorIsOpen}
        onClose={(tuote) => handleTuoteSelectorClose(tuote)}
        laskuttajaAsiakasId={ownerAsiakasId}
      />
    </div>
  );
}

EditVehicle.propTypes = {
  vehicle: PropTypes.object,
  setVehicle: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
